module.exports = __webpack_public_path__ + "img/ca9d77c.png";